import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import _isEmpty from 'lodash/isEmpty';

import { Card } from 'components/Card';
import LoadingDots from 'components/LoadingDots';
import Message from 'components/Message';
import { intlMessage } from 'constants/propTypes';
import RatingsSummaryItem from './RatingsSummaryItem';

import './RatingsSummary.scss';

const messages = defineMessages({
  appointments: {
    id: 'ratings.ratings-summary.appointments',
    defaultMessage: 'Appointments',
  },
  classes: {
    id: 'ratings.ratings-summary.classes',
    defaultMessage: 'Classes',
  },
  orders: {
    id: 'ratings.ratings-summary.orders',
    defaultMessage: 'Orders',
  },
  sessions: {
    id: 'ratings.ratings-summary.sessions',
    defaultMessage: 'Sessions',
  },
});

const ClassesRatingsSummaryLoader = ({ message }) => {
  return (
    <Card className="pb-r" flush>
      <Message as="div" className="grid__item 1/1 ratings-summary__header" message={message} />
      <div className="ratings-summary__loader">
        <LoadingDots />
      </div>
    </Card>
  );
};

const ClassesRatingsSummary = ({
  classesRatings,
  isLoading,
  offersAppointments,
  offersClasses,
  updateClass,
  isVenueFoodAndBeverage,
}) => {
  let message = messages.sessions;
  if (isVenueFoodAndBeverage) {
    message = messages.orders;
  } else if (offersAppointments && !offersClasses) {
    message = messages.appointments;
  } else if (offersClasses && !offersAppointments) {
    message = messages.classes;
  }

  if (isLoading) return <ClassesRatingsSummaryLoader message={message} />;
  if (_isEmpty(classesRatings)) return null;

  return (
    <Card flush>
      <Message as="div" className="grid__item 1/1 ratings-summary__header" message={message} />
      {classesRatings.map(({ ratingsCount, averageRating, className, classId }) => (
        <RatingsSummaryItem
          key={classId}
          id={classId}
          title={className}
          ratingsCount={ratingsCount}
          averageRating={averageRating}
          onViewClick={updateClass}
        />
      ))}
    </Card>
  );
};

ClassesRatingsSummaryLoader.propTypes = {
  message: intlMessage,
};

ClassesRatingsSummary.propTypes = {
  classesRatings: PropTypes.arrayOf(
    PropTypes.shape({
      ratingsCount: PropTypes.number,
      averageRating: PropTypes.number,
      className: PropTypes.string,
      classId: PropTypes.number,
    })
  ),
  offersAppointments: PropTypes.bool,
  offersClasses: PropTypes.bool,
  updateClass: PropTypes.func,
  isLoading: PropTypes.bool,
  isVenueFoodAndBeverage: PropTypes.bool,
};

export default ClassesRatingsSummary;
